import React from 'react';
import PropTypes from 'prop-types';
import { FaqBlockHeading } from './faqBlockHeading';
import { QuestionPanel } from './questionPanel/questionPanel';
import { FaqsHeadingPropTypes, FaqsQuestionsPropTypes } from '../../../propTypes/faqs';

import './faqsBlock.scss';

export const FaqsBlock = ({ heading, maxNumber, questionSet, redirectToQuestion, onQuestionToggle }) => {
  return (
    <div className="faqsBlock">
      {heading && <FaqBlockHeading heading={heading} />}
      {questionSet
        ?.filter((question, key) => {
          if (maxNumber) {
            return key < maxNumber;
          }

          return question;
        })
        .map((question, index) => (
          <QuestionPanel
            index={index + 1}
            key={question.id}
            item={question}
            redirectToQuestion={redirectToQuestion}
            onQuestionToggle={onQuestionToggle}
          />
        ))}
    </div>
  );
};

FaqsBlock.propTypes = {
  heading: FaqsHeadingPropTypes,
  maxNumber: PropTypes.number,
  questionSet: FaqsQuestionsPropTypes,
  redirectToQuestion: PropTypes.string,
  onQuestionToggle: PropTypes.func
};
